import { useAppSelector } from '../../hooks/app';
import { selectOmeApplications, selectOmeApplicationsLoaded, selectOmeApplyInProgress } from './selectors';

export const useOmeApplications = () => useAppSelector(selectOmeApplications);
export const useOmeApplicationsLoaded = () => useAppSelector(selectOmeApplicationsLoaded);
export const useOmeApplyInProgress = () => useAppSelector(selectOmeApplyInProgress);
